<template>
  <div>
    <Header :code="code" :team_id="team_id" points="-" />

    <div class="game-texture-layer"></div>

    <div class="cont-fullwidth black-bg white-text">
      <div class="row d-flex align-items-center vh-20">
        <div class="col-12 text-center">
          <h3 class="termina-black" style="text-transform: uppercase;">
            Live Game Feed
          </h3>
        </div>
      </div>
    </div>

    <!-- activity feed -->
    <div class="cont-fullwidth black-bg white-text">
      <div class="row d-flex  pad-left-30 pad-right-30">
        <div
          v-for="(activityItem, index) in activity.activity"
          :key="index"
          data-aos="fade-in"
          class="d-flex flex-fill col-6 mb-2"
        >
          <div class="activity-item">
            <h5 class="termina-black">Update</h5>

            <h2 class="termina-reg pad-right-30">
              {{ activityItem.text }}
            </h2>

            <!-- <p class="termina-reg mb-0 pb-0">added just now</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'
import { mapState, mapActions } from 'vuex'
import Header from '@/components/Header.vue'

export default {
  mixins: [gameAssetsMixin],
  components: {
    Header
  },
  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  computed: {
    ...mapState({
      game: state => state.game,
      activity: state => state.activity
    }),
    gameData() {
      return this.game.teamData.gameData
    },
    gameID() {
      return this.game.teamData.game
    },
    loading() {
      return this.gameData === undefined
    }
  },
  methods: {
    ...mapActions('game', ['fetchTeamData'])
  }
}
</script>
<style scoped></style>
